import { FormAddonGroup } from '@/features/pos/components/ProductConfigurationModal/form/types'
import { RefObject, useEffect, useRef } from 'react'

export const useFormAddonGroupRef = (formAddonGroup: FormAddonGroup): RefObject<FormAddonGroup> => {
    const formAddonGroupRef = useRef(formAddonGroup)

    useEffect(() => {
        formAddonGroupRef.current = formAddonGroup
    }, [formAddonGroup])

    return formAddonGroupRef
}
